<template>
  <div class="d-flex h-full flex-column">
    <TopAppBar
        ref="top_app_bar"
        :leftBtnMethod="leftBtnMethod"
        :leftBtnMode="leftBtnMode"
        :rightBtnMethod="rightBtnMethod"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :hideCategory="true"
    >
    </TopAppBar>

    <TopAppBarDrawer></TopAppBarDrawer>

    <section class="main-wrapper full flex-grow-1 scroll-y">
      <div class="container container--small pdt-50">
        <title-block v-if="!this.$route.query.memberId" :titleData="{msg1: '3540', msg2: '3541', str: memberName}">
          <div class="t-color-red">
            {{ $t("3533") }}
          </div>
        </title-block>
        <title-block v-else
                     :titleData="{msg1: '3579', msg2: '3580', str: memberName}"></title-block>

        <content-card
            :contentData="{msg1: '3534', msg2: '3581', str1: telegramBot, msg3: '3536', msg4: '3531', str2: telegramBot, msg5: '3537', msg6: '3532'}"
            class="mgt-24 ">
          <div class="t-body3 pdt-8 t-color-signBlue font-r t-decoration-underline" @click="goToTelegramBot()" @keypress="goToTelegramBot()">
            {{ $t('3535') }}
          </div>
        </content-card>

        <div class="pdl-24 pdr-24 mgt-50 mgb-50">
          <button
              class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full b-radius4 mgb-16"
              tabindex="0"
              @click="messageAuthCheck()" @keypress="messageAuthCheck()">
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body2 font-r">{{ $t("3538") }}</span>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import memberApi from "@/api/memberApi.js";
import joinApi from "@/api/joinApi";

import {MDCRipple} from "@material/ripple";
import {mapMutations, mapState} from "vuex";

import titleBlock from "@/components/popup/components/titleBlock";
import contentCardBlock from "@/components/popup/components/contentCardBlock";
import TopAppBarDrawer from "@/components/TopAppBarDrawer";
import {userTypeConstants} from "@/utils/enum/ApplicationTypeConstants";
import {storageConstants} from "@/utils/enum/StorageConstants";

export default {
  name: "TelegramMessageAuth",
  data() {
    return {
      BRAND_CODE: localStorage.getItem(storageConstants.brandCode),
      title: localStorage.getItem(storageConstants.brandName),
      telegramBot: localStorage.getItem(storageConstants.telegramBot),
      telegramBotUrl: localStorage.getItem(storageConstants.telegramUrl),
      leftBtnMode: "",
      rightBtnMode: "",
      leftBtnMethod: "",
      rightBtnMethod: "",
      memberName: "",
    };
  },
  computed: {
    ...mapState('join', {
      join: state => state,
    }),
  },

  components: {
    TopAppBar,
    TopAppBarDrawer,
    'title-block': titleBlock,
    'content-card': contentCardBlock
  },

  mounted() {
    this.setMaterialUi();

    let params = JSON.parse(localStorage.getItem(storageConstants.userParams));
    this.memberName = params.userId;
  },

  methods: {
    ...mapMutations('join', ['SET_STORE', 'INIT_JOIN_STORE']),

    messageAuthCheck() {
      let params = {
        memberId: this.$route.query.memberId
      };

      if (this.$route.query.memberId !== undefined) {

        joinApi.guestUserInfo(params).then((response) => {
          let responseData = response.data.data[0];

          if (responseData.applicationType.value === userTypeConstants.student && responseData.notificationed) {
            this.$router.push({name: 'Join2CompleteUnapproved'})
          } else {
            this.$snackOpen({contents: this.$t('3539'), btnDisplayYN: false}).then(() => {
            });
          }
        });

      } else {
        memberApi.getMemberInfo().then((response) => {
          let responseData = response.data.data;

          if (responseData.option.notificationed) {
            this.setDialog();
          } else {
            this.$snackOpen({contents: this.$t('3539'), btnDisplayYN: false}).then(() => {
            });
          }
        });
      }
    },

    setDialog() {
      let params = {
        title: this.$t("3555"), // "로그아웃 후 다시 로그인해주세요",
        content: this.$t("3542"), // "로그아웃 후 텔레그램을 통하여 다시 로그인해주세요",
        accept: this.$t("3554"),
      };
      this.$alert(params)
          .then(() => {
            this.$moveLogin();
            firebase.auth().signOut();
          })
          .catch(() => {
          });
    },

    goToTelegramBot(rel = "noopener noreferrer") {
      window.open(this.telegramBotUrl, rel);
    },

    setMaterialUi() {
      const buttonRipple = [].map.call(
          document.querySelectorAll(".mdc-button"),
          function (el) {
            let button = new MDCRipple.attachTo(el);
            return button;
          }
      );
    },
  },
};
</script>
